import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';

const backendAdapter = createEntityAdapter({
  selectId: (e) => e.backend_id,
});

const initialState = backendAdapter.getInitialState();

export const backendApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLiveActivities: builder.query({
      query: () => ({
        url: `/backend/live-activities`,
        method: 'GET',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getActivityById: builder.query({
      query: (activityId) => ({
        url: `/backend/activity-detail/${activityId}`,
        method: 'GET',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
  }),
});

export const { useGetLiveActivitiesQuery, useGetActivityByIdQuery } =
  backendApiSlice;
